import React from 'react';
import PropTypes from 'prop-types';
import CalendarButton from '../CalendarButton/CalendarButtonComponent';
import './CalendarButtonListComponent.scss';
import {GoogleIcon, OutlookIcon} from './CalenderIcons';

function CalendarButtonList(props) {
  const { openProvider, externalProviders, revokeAccess, refreshCalendar } = props;
  return (
    <React.Fragment>
      <CalendarButton
        icon={<GoogleIcon />}
        text={<span className="calenderButtonText">Sign in with Google</span>}
        openProvider={openProvider}
        externalProviders={externalProviders}
        name="google"
        revokeAccess={revokeAccess}
        refreshCalendar={refreshCalendar}
      />
      <CalendarButton
        icon={<OutlookIcon />}
        text={<span className="calenderButtonText">Sign in with Office365</span>}
        openProvider={openProvider}
        externalProviders={externalProviders}
        name="outlook"
        revokeAccess={revokeAccess}
        refreshCalendar={refreshCalendar}
      />
    </React.Fragment>
  );
}

CalendarButtonList.propTypes = {
  openProvider: PropTypes.func.isRequired,
  externalProviders: PropTypes.shape({}),
  revokeAccess: PropTypes.func.isRequired,
  refreshCalendar: PropTypes.func.isRequired,
};

CalendarButtonList.defaultProps = {
  externalProviders: {},
};
export default CalendarButtonList;
